module.exports = __webpack_public_path__ + "img/Druid-tauren-m-70.1be40999.gif";